import { Text, StyleSheet } from '@react-pdf/renderer';

const style = StyleSheet.create({
  pdfParagraphStyle: {
    width: '100%',
    margin: '20px 0',
  },
  pdfOneLineTextStyle: {
    margin: '8px 0',
  },
});

export const PdfParagraph: React.FC<{
  isOneLineText?: boolean;
}> = ({ isOneLineText, ...props }) => (
  <Text
    style={[
      style.pdfParagraphStyle,
      isOneLineText ? style.pdfOneLineTextStyle : {},
    ]}>
    {props.children}
  </Text>
);
